"use client";

import {
	type DefaultImageProps,
	type DefaultLinkProps,
	Heading,
	type HeadingProps,
	Image,
	type ImageProps,
	Link,
	type LinkProps,
	Price,
	type PriceProps,
	Rating,
	type RatingProps
} from "@pamperedchef/design-system";

import * as styles from "./WhatsIncluded.module.scss";

interface WhatsIncludedProps<
	ImageComponentProps = DefaultImageProps,
	LinkComponentProps = DefaultLinkProps
> {
	heading: HeadingProps;
	items: {
		image: ImageProps<ImageComponentProps>;
		price?: PriceProps;
		rating?: RatingProps;
		cta: LinkProps<LinkComponentProps>;
	}[];
}

/**
 * What's Included component
 */
export function WhatsIncluded<
	ImageComponentProps = DefaultImageProps,
	LinkComponentProps = DefaultLinkProps
>({
	heading,
	items
}: WhatsIncludedProps<ImageComponentProps, LinkComponentProps>): JSX.Element {
	return (
		<div className={styles["whats-included"]}>
			<Heading {...heading} className={styles["heading"]} />
			<div className={styles["items"]}>
				{items.map((item, index) => (
					<article key={index} className={styles["item"]}>
						<Image
							{...item.image}
							className={styles["image"]}
							alt={item.image.alt || ""}
						/>
						<div className={styles["content"]}>
							<Link
								{...item.cta}
								kind="tertiary"
								className={styles["cta"]}
							/>
							{item.rating && (
								<Rating {...item.rating} size="small" />
							)}
							{item.price && <Price {...item.price} />}
						</div>
					</article>
				))}
			</div>
		</div>
	);
}
